import React from 'react';
import {Alert, AlertTitle, SnackbarOrigin} from '@mui/material';
import {Snackbar} from 'presentation/components';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';
import {ErrorSnackbarProps} from './types';

const {chatErrorTitle, chatErrorDescription} = translations['pt-br'].commons;

export function ErrorSnackbar({
	open,
	onClose,
	title = chatErrorTitle,
	description = chatErrorDescription,
}: ErrorSnackbarProps) {
	const {isMobile} = useMediaQueries();
	const snackPosition: SnackbarOrigin = isMobile
		? {vertical: 'top', horizontal: 'center'}
		: {vertical: 'top', horizontal: 'right'};

	return (
		<Snackbar anchorOrigin={snackPosition} open={open} onClose={onClose} autoHideDuration={6000}>
			<Alert sx={{maxWidth: 320, textAlign: 'left'}} severity="error">
				<AlertTitle>{title}</AlertTitle>
				{description}
			</Alert>
		</Snackbar>
	);
}